import { render } from "./goal-type-table.vue?vue&type=template&id=64233d87"
import script from "./goal-type-table.vue?vue&type=script&lang=js"
export * from "./goal-type-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__